<!--
 * @Author: 陈红伟 chenhw2019@gmail.com
 * @Date: 2023-10-11 14:46:57
 * @LastEditors: 陈红伟 chenhw2019@gmail.com
 * @LastEditTime: 2024-03-06 10:10:29
 * @FilePath: /seller.sviptrader.com/src/views/configure/rulesManage/list/components/talentClue/components/distribute.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="distribute-wrapper">
		<el-button v-if="isSearch" type="primary" @click="handleEdit" v-auth="['configure:rules:talentClue:distribute:edit']">编辑规则</el-button>
		<div class="rule-show mt-16" v-if="isSearch">
			<InfoCard title="线索达人自动分配规则">
				<template slot="content">
					<div class="rule-type yx-color-text-primary font-h4-regular">{{ distributeTypeDesc }}</div>
					<div class="yx-color-text-primary font-h4-regular" v-if="showSortTable()">{{ distributeTypeDesc }}达人：{{ selectUsersDesc }}</div>
				</template>
			</InfoCard>
			<div class="content"></div>
		</div>
		<template v-if="isEdit && $auth.hasPermi('configure:rules:talentClue:distribute:edit')">
			<div class="edit-wrapper flex-row flex-just-start mt-24">
				<div class="label font-h4-medium yx-color-text-primary">
					线索达人自动分配规则
					<span class="color-gy-7 font-h6-regular ml-4 cursor-pointer" @click="dialogVisible = true">《规则说明》</span>
				</div>
				<div class="edit-content ml-16 font-h4-regular">
					<el-radio-group class="flex-column" v-model="distributeType">
						<div class="font-h4-regular mb-16" v-for="item in radioBtnList" :key="item.value">
							<el-radio :disabled="item.disabled" :label="item.value">{{ item.label }}</el-radio>
							<div v-if="showSortTable(item.value)" class="sort-table-outter mt-12">
								<el-button
									icon="el-icon-plus
								"
									@click="addAccount"
								>
									编辑达人商务
								</el-button>
								<span class="ml-8 font-h6-regular yx-color-text-regular">已选 {{ selectUsers.length }} 个达人商务</span>
								<DragSortTable
									maxHeight="340"
									class="mt-10"
									:draggable="item.drag"
									:list="selectUsers"
									@sortTableChange="sortTableChangeHandle"
									:columns="getColumns()"
								></DragSortTable>
							</div>
						</div>
					</el-radio-group>
				</div>
			</div>
			<div class="operate-bottom">
				<el-button @click="cancel">取消</el-button>
				<el-button type="primary" @click="submit">保存</el-button>
			</div>
		</template>
		<el-dialog class="cooperationProgress_monitoring_dialog" :visible.sync="dialogVisible" width="400px" :close-on-click-modal="false">
			<div slot="title">
				<span class="fz-14 yx-pingfang-Medium yx-color-g-9">规则说明</span>
			</div>
			<div class="font-h4-medium">符合【线索筛选条件】、【线索过滤规则】的达人会按【线索分配规则】来分配，各分配规则逻辑如下：</div>
			<div class="font-h4-regular cooperationProgress_monitoring_bullets font-h4-regular mt-8">
				收录至团队公海由员工认领：只收录不做分配，由员工自行在团队公海认领；
			</div>
			<div class="font-h4-regular cooperationProgress_monitoring_bullets font-h4-regular">
				轮流分配：按已选达人商务序号依次分配达人，实现线索达人平均分配；
			</div>
			<div class="font-h4-regular cooperationProgress_monitoring_bullets font-h4-regular">
				随机分配：按已选达人商务随机分配达人，不保证线索达人分配是否平均；
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="dialogVisible = false">我知道了</el-button>
			</span>
		</el-dialog>
		<ChooseUserDrawer :selectable="selectableHandle" ref="chooseUserDrawer" @selectChange="selectChangeFn"></ChooseUserDrawer>
		<CancelDialog @back="back" ref="cancelDialog" />
	</div>
</template>

<script>
import ChooseUserDrawer from '@/components/business/chooseUserDrawer';
import DragSortTable from '@/components/business/dragSortTable';
import { allotRuleInfo, setDistributeRule } from '@/api/settings';
import CancelDialog from '@/views/settings/components/cancelDialog.vue';
import InfoCard from './infoCard.vue';
import { allotStatusMap, radioBtnList } from '../const';
import { getColumns } from './columns';

export default {
	data() {
		return {
			dialogVisible: false,
			radioBtnList,
			allotStatusMap,
			mode: 'search',
			distributeType: allotStatusMap.FreeSea,
			selectUsers: [],
			selectUsersDesc: '',
			sortedSelectUsers: [],
			disabledList: [],
		};
	},
	components: {
		DragSortTable,
		InfoCard,
		CancelDialog,
		ChooseUserDrawer,
	},
	computed: {
		isEdit() {
			return this.mode === 'edit';
		},
		isSearch() {
			return this.mode === 'search';
		},
		// 分配类型中文描述
		distributeTypeDesc({ distributeType }) {
			return radioBtnList.find(item => item.value == distributeType)?.label;
		},
	},
	async created() {
		this.allotRuleInfo();
	},
	methods: {
		// 员工数据是否可选
		selectableHandle(row) {
			// 停用的不可以选择
			return row.use_status !== '2' && !row.deleted;
		},
		getColumns,
		// 是否展示选择达人允许排序组件
		showSortTable(type = this.distributeType) {
			return [allotStatusMap.TurnAllot, allotStatusMap.RandomAllot].includes(type) && type === this.distributeType;
		},
		// 排序回调
		sortTableChangeHandle(list) {
			this.sortedSelectUsers = list;
		},
		// 获取分配规则数据
		async allotRuleInfo() {
			const { allotRuleType, userList } = await allotRuleInfo({
				platformId: dataMap.PLATFORM_DY.value,
			});
			this.distributeType = allotRuleType;
			if (!this.distributeTypeDesc) {
				// 如果未设置默认收录至团队公海由员工自行认领
				this.distributeType = allotStatusMap.FreeSea;
				this.mode = 'edit';
				return;
			}
			this.selectUsers = this.handleButtons(userList)
				.sort((a, b) => a.sort - b.sort)
				.map(item => {
					const { nickname, deptName } = item;
					return {
						...item,
						name: nickname,
						dept_name: deptName,
					};
				});
			this.selectUsersDesc = this.selectUsers.map(item => item.nickname).join('、');
		},
		handleButtons(list) {
			return list.map(item => {
				return {
					...item,
					operations: [
						{
							label: '移除',
							type: 'text',
							bigger: false,
							classtype: 2,
							click: row => {
								this.deleteItem(row);
							},
						},
					],
				};
			});
		},
		deleteItem(item) {
			this.$modal({
				title: '确认移除该达人商务？',
				content: `移除后该员工将不参与${this.distributeTypeDesc}`,
				size: 'small',
				btns: [
					{
						type: 'default',
						text: '取消',
						key: 'cancel',
					},
					{
						type: 'primary',
						text: `确认移除`,
						key: 'confirm',
					},
				],
			})
				.then(res => {
					if (res.key == 'confirm') {
						this.selectUsers = this.selectUsers.filter(cur => cur !== item);
						res.done();
					} else {
						res.done();
					}
				})
				.catch(() => {});
		},
		async submit() {
			if (this.showSortTable(this.distributeType) && !this.selectUsers?.length) {
				this.$message.warning('请选择分配的达人商务');
				return;
			}
			let params = {
				platformId: dataMap.PLATFORM_DY.value,
				allotType: this.distributeType,
			};
			if (this.showSortTable(this.distributeType)) {
				params.userList = this.sortedSelectUsers.map(({ userId, nickname, deptName }, index) => ({
					userId,
					sort: index,
					nickname,
					deptName,
				}));
			}
			await setDistributeRule(params);
			this.$message.success('保存成功');
			this.mode = 'search';
			this.allotRuleInfo();
		},
		addAccount() {
			this.$refs.chooseUserDrawer.show(this.selectUsers);
		},
		// 选择员工回调用
		selectChangeFn(list) {
			this.selectUsers = this.handleButtons(
				list.map(item => {
					const { id, name, dept_name } = item;
					return {
						userId: id,
						name,
						dept_name,
					};
				}),
			);
			console.log(this.selectUsers);
		},
		cancel() {
			this.$refs.cancelDialog.show();
		},
		back() {
			this.mode = 'search';
		},
		async handleEdit() {
			this.mode = 'edit';
		},
	},
};
</script>

<style lang="less" scoped>
.operate-bottom {
	position: fixed;
	bottom: 0;
	left: 148px;
	height: 64px;
	right: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.08), 0px -2px 6px 0px rgba(0, 0, 0, 0.06), 0px -4px 8px 2px rgba(0, 0, 0, 0.04);
}
.sort-table-outter {
	background: @color-gy2;
	border-radius: 4px;
	padding: 16px;
}
</style
>./columns
